import {API, Auth} from 'aws-amplify';
import React, { Component } from 'react';
import Ec2PaRequiredAttention from './ec2PaRequiredAttention/ec2PaRequiredAttention.js';
import './ec2PaContent.css';

class Ec2PaContent extends Component {

  state = {
    commandsRequireAttention: [],
    username: ''
  };

  componentDidMount() {
    setTimeout(() => {
      this.scanRequiresAttention();
    }, 0);
  };

  scanRequiresAttention = () => {
    API.get('WBU', '/ec2commands', {
      queryStringParameters: {
        action: 'scan'
      }
    })
    .then(res => {
      this.setState({commandsRequireAttention: [...res.Items]});
      return Auth.currentAuthenticatedUser();
    })
    .then(res => {
      this.setState({username: res.username});
    })
    .catch(err => {
      console.log(err);
    });
  }

  render() {

    const {username} = this.state;

    return (
      <div className="Ec2PaContentPage">
        {this.state.commandsRequireAttention.sort(this.commandSort).map(command => {
          return <Ec2PaRequiredAttention key={command.CommandId} command={command} username={username}/>;
        })}
      </div>
    );

  };

  commandSort = (a, b) => {
    const aDate = a.RequestedDateTime;
    const bDate = b.RequestedDateTime;
    const sortArray = [aDate, bDate];
    if (sortArray.sort()[0] === aDate) return 1;
    else return -1;
  }

};

export default Ec2PaContent;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PaContent/ec2PaContent.js